module.exports = __webpack_public_path__ + "img/valid.00682ac9.svg";